/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Normalise a list response. Travel lists return a bare array; Real Estate
 * lists return {items, total, page, page_size}. Anything else with an
 * items/results/data array is accepted too.
 */
export function normalizeListResponse(data) {
  if (Array.isArray(data)) {
    return { items: data, total: data.length, page: 1, pageSize: data.length || 0, paged: false };
  }
  if (data && typeof data === "object") {
    const items = Array.isArray(data.items)
      ? data.items
      : Array.isArray(data.results)
        ? data.results
        : Array.isArray(data.data)
          ? data.data
          : [];
    return {
      items,
      total: Number.isFinite(Number(data.total)) ? Number(data.total) : items.length,
      page: Number(data.page) || 1,
      pageSize: Number(data.page_size) || items.length || 0,
      paged: data.total !== undefined,
    };
  }
  return { items: [], total: 0, page: 1, pageSize: 0, paged: false };
}

/** A human message from an API error ({detail: {message}} or {detail: "..."}). */
export function apiErrorMessage(error, fallback = "Something went wrong") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message) return detail.message;
    if (typeof detail.error_code === "string") return detail.error_code.replace(/_/g, " ").toLowerCase();
  }
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return error?.response?.data?.message || fallback;
}
